import React from 'react';

import useStyles from './styles';

interface Props {
    text: string;
    orientation?: 'vertical' | 'horizontal';
    children?: React.ReactNode;
    className?: string;
}

const Heading: React.FC<Props> = ({ text, orientation = 'horizontal', children, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div
            className={cx(
                classes.root,
                {
                    [classes._vertical]: orientation === 'vertical',
                    [classes._horizontal]: orientation === 'horizontal'
                },
                className
            )}
        >
            <h1 className={classes.header}>{text}</h1>
            {children}
        </div>
    );
};

export default Heading;
